import { LightShowSegment } from './lightshow-segment';
import { LightShowOperation } from '../Operations/lightshow-operation';
import { ImageFadeinnOperation as ImageFadeinOperation } from '../Operations/image-fadein-operation';
import { ImageFadeoutOperation } from '../Operations/image-fadeout-operation';
import { SetColorOperation } from '../Operations/set-color-operation';
import { FlashTypes } from '../operation-types';

export class ImageSegment extends LightShowSegment {
  static fadeInTime = 10;
  static fadeOutTime = 300;
  static colorFadeInTime = 250;
  static minDuration = 200;
  public imageUrl: string;
  public imageBackgroundColor: string;

  public addOperations(operations: LightShowOperation[]) {
    operations.push(new ImageFadeinOperation(this.position, this.fadeIn, this.imageUrl));
    this.fadeIn > 0 && operations.push(new SetColorOperation(this.position <= 10 ? 0 : this.position - 10, this.fadeIn, this.imageBackgroundColor, 0, 0));
    operations.push(new ImageFadeoutOperation(this.position + this.duration - this.fadeOut - 100, this.fadeOut));
    this.fadeOut > 0 && operations.push(new SetColorOperation(this.position + this.duration - this.fadeOut, this.fadeOut, '#000000', 0, 0));
  }

  init() {
    this.color = 'green';
    this.minDuration = this.fadeIn + this.fadeOut;
    this.enableSegmentGrips = true;
  }
}
